import { get, isArray } from 'lodash';
import { shallowEqual, useSelector } from 'react-redux';

import { getCurrentLeg, getCurrentLegCrewType, getCurrentLegInfo } from '../../../selectors/screen';
import { useLanguage } from '../../hooks/useLanguage/useLanguage';

export const useCurrentLegInfo = () => {
    const { isEng} = useLanguage();
    const { currentLegInfo = '', plnName } = useSelector((state) => {
        const leg = getCurrentLeg(state) || {};
        const currentLegInfo = getCurrentLegInfo(state);

        return {
            currentLegInfo: isArray(currentLegInfo) ? currentLegInfo[Number(isEng)] : currentLegInfo,
            plnName: get(leg, 'plnName', ''),
        };
    }, shallowEqual);
    const crewType = useSelector(getCurrentLegCrewType);

    return {
        crewType,
        currentLegInfo,
        plnName,
    };
};
